import type { AbacPermission } from "../types/abac.type";

export const ADMIN_ABAC_PERMISSION: AbacPermission = { can: "readAll", model: "Admin" };
